(() => {
  function init(root = document) {
    root.querySelectorAll('[data-ind-country]').forEach(country => {
      if (country.dataset.ready) return;
      country.dataset.ready = 'true';
      const province = country.closest('form').querySelector('[data-ind-province]');
      if (country.dataset.selected) country.value = country.dataset.selected;
      function refreshProvinces() {
        let options = [];
        try { options = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]'); } catch {}
        province.replaceChildren(...options.map(([value, label]) => new Option(label, value)));
        province.closest('label').hidden = options.length === 0;
        province.disabled = options.length === 0;
      }
      refreshProvinces();
      if (province.dataset.selected) province.value = province.dataset.selected;
      country.addEventListener('change', refreshProvinces);
    });
    root.querySelectorAll('[data-ind-print]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => window.print());
    });
  }
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

(() => {
  const arrowPaths = {
    '→': 'M4 12h16m-6-6 6 6-6 6',
    '←': 'M20 12H4m6-6-6 6 6 6',
    '↑': 'M12 20V4M6 10l6-6 6 6',
    '↓': 'M12 4v16M6 14l6 6 6-6',
    '↗': 'M5 19 19 5M6 5h13v13',
    '↘': 'M5 5l14 14M6 19h13V6',
    '↖': 'M19 19 5 5m13 0H5v13',
    '↙': 'M19 5 5 19m13 0H5V6'
  };
  const arrowPattern = /[→←↑↓↗↘↖↙]\uFE0F?/g;
  const arrowContext = 'a,button,summary,[aria-hidden="true"],.vp-announcement';
  const skipContext = 'script,style,textarea,select,input,svg,code,pre,[contenteditable="true"],[data-atelier-arrow]';
  function createArrow(symbol) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '24');
    svg.setAttribute('height', '24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('data-atelier-arrow', symbol);
    svg.setAttribute('style', 'display:inline-block;width:1em;height:1em;min-width:1em;flex:none;vertical-align:-.12em;overflow:visible;pointer-events:none');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', arrowPaths[symbol]);
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.65');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.append(path);
    return svg;
  }
  function replaceArrowText(node) {
    const parent = node.parentElement;
    if (!parent || parent.closest(skipContext) || !parent.closest(arrowContext)) return;
    const text = node.nodeValue;
    arrowPattern.lastIndex = 0;
    const matches = [...text.matchAll(arrowPattern)];
    if (!matches.length) return;
    const control = parent.closest('a,button,summary');
    if (control && !control.hasAttribute('aria-label') && !control.hasAttribute('aria-labelledby') && !control.textContent.replace(arrowPattern, '').trim()) return;
    const fragment = document.createDocumentFragment();
    let cursor = 0;
    for (const match of matches) {
      fragment.append(document.createTextNode(text.slice(cursor, match.index)), createArrow(match[0][0]));
      cursor = match.index + match[0].length;
    }
    fragment.append(document.createTextNode(text.slice(cursor)));
    node.replaceWith(fragment);
  }
  function upgradeArrows(root) {
    if (root.nodeType === Node.TEXT_NODE) { replaceArrowText(root); return; }
    if (root.nodeType !== Node.ELEMENT_NODE || root.closest(skipContext)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(replaceArrowText);
  }
  function watchArrows() {
    upgradeArrows(document.body);
    const observer = new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'characterData') upgradeArrows(record.target);
        else record.addedNodes.forEach(upgradeArrows);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchArrows, { once: true });
  else watchArrows();
})();
